// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".doc-box[data-v-f1e900b8]{display:inline-block}", ""]);
// Exports
module.exports = exports;
